import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ISetProjectControlledPermissionsParams {
  ids: string[];
  nestedProjectsPermissionsIncluded?: boolean;
}

export class SetProjectControlledPermissionsRequest
    extends Request<ISetProjectControlledPermissionsParams, IEmptyResult> {
  constructor(params: ISetProjectControlledPermissionsParams) {
    super('setProjectControlledPermissions', params);
  }
}
